"use strict";

import Page from "./AddSettings";

export const auth = true;
export const title = "i18n:permits.permitters.pageTitle";
export const Component = Page;
